<toolbar #toolbar [showHome]="true" (langChanged)="langChanged()">
  <span style="margin-left: 10px">
    <tableviewoptions
      [settings]="options"
      (changed)="optionsChanged($event)"
    ></tableviewoptions>
  </span>
</toolbar>
<div class="content noselect" (click)="select(null, $event)">
  <nz-table
    #table
    [nzData]="set.rows"
    [nzBordered]="true"
    [nzShowPagination]="false"
    [nzPageSize]="pagesize"
    [ngStyle]="{ width: '99.0%' }"
    [nzScroll]="{ y: tableHeight }"
    nzSize="small"
  >
    <thead>
      <tr *ngFor="let h of set.headers">
        <th
          *ngFor="let column of h; trackBy: trackByName"
          [nzAlign]="column.align || 'center'"
          [nzFilterMultiple]="true"
          [nzFilters]="column.listOfFilter"
          [nzWidth]="column.width"
          [ngStyle]="{ cursor: column.cursor }"
          [colSpan]="column.colSpan"
          [style.background-color]="column.backgroundColor"
          [rowSpan]="column.rowSpan"
          (click)="select(column.refId, $event)"
          (nzFilterChange)="filterChange($event, column.name)"
        >
          <img
            *ngIf="column.icon"
            class="abilityIcon"
            style="margin-right: 2px; margin-top: -3px"
            [style.width]="(column.iconSize || 24) + 'px'"
            [style.height]="(column.iconSize || 24) + 'px'"
            [src]="column.icon"
          />
          <span *ngIf="!column.icon || (column.icon && showText)">{{
            column.text
          }}</span>
        </th>
      </tr>
    </thead>
    <tbody cdkDropListGroup>
      <tr *ngFor="let row of filtered">
        <td
          *ngFor="let col of row.cells; let i = index"
          cdkDropList
          [cdkDropListEnterPredicate]="canDrop"
          [cdkDropListSortingDisabled]="true"
          [cdkDropListData]="{row, col: set.columns[i]}"
          [nzAlign]="col.align || 'left'"
          [ngStyle]="{
            'background-color': isAvailableToDrop({ row, col: set.columns[i] })
              ? '#1eff0024'
              : (col.colorFn && col.colorFn(row.filterData)) || ''
          }"
          (click)="
            select(
              (col.bgRefIdFn && col.bgRefIdFn(row.filterData)) || '',
              $event
            )
          "
          (cdkDropListDropped)="onDrop($event)"
        >
          <cell
            [input]="col"
            [showText]="showText"
            [showIcon]="showIcon"
            [showOffset]="showOffset"
            [showTarget]="showTarget"
            [iconSize]="iconSize"
            (selected)="select($event)"
            (dragStarted)="dragStarted($event)"
          ></cell>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
<sidepanel #sidepanel mode="table"></sidepanel>
<ng-progress
  #progressBar
  [speed]="500"
  [trickleSpeed]="30000"
  [spinner]="false"
></ng-progress>
